import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { captureTracking } from "@/lib/tracking";
import { initMetaPixel, initGhlTracking, trackMetaPageView, trackContactClick } from "@/lib/metaPixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  try {
    let id = localStorage.getItem("ah_visitor_id");
    if (!id) {
      id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`);
      localStorage.setItem("ah_visitor_id", id);
    }
    return id;
  } catch {
    return "";
  }
}

export default function PageTracker() {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    initMetaPixel();
    initGhlTracking();
    const onClick = (e) => {
      if (window.location.pathname.startsWith("/admin")) return;
      const a = e.target.closest?.('a[href^="tel:"]');
      if (a) trackContactClick();
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    // Redirect-only routes (they immediately <Navigate> elsewhere) — the destination fires the PageView.
    if (location.pathname === "/special") return;
    const key = location.pathname + location.search;
    if (lastTracked.current === key) return;
    lastTracked.current = key;
    trackMetaPageView(key);
    captureTracking(location.search, document.referrer || "");
    const params = new URLSearchParams(location.search);
    axios.post(`${API}/track/visit`, {
      path: location.pathname,
      referrer: document.referrer || "",
      utm_source: params.get("utm_source") || "",
      utm_campaign: params.get("utm_campaign") || "",
      src: params.get("src") || params.get("source") || "",
      visitor_id: getVisitorId(),
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
